
export const mapDayToThaiShortName = (fullDayName) => {
    const dayMapping = {
      Sunday: "อา.",
      Monday: "จ.",
      Tuesday: "อ.",
      Wednesday: "พ.",
      Thursday: "พฤ.",
      Friday: "ศ.",
      Saturday: "ส.",
    };

    // Convert to Thai short name if mapping exists, otherwise return the original value
    return dayMapping.hasOwnProperty(fullDayName)
      ? dayMapping[fullDayName]
      : fullDayName;
  };

export const mapDayToThai = (dayOfWeek) => {
    const dayMapping = {
      'Monday': 'จันทร์',
      'Tuesday': 'อังคาร',
      'Wednesday': 'พุธ',
      'Thursday': 'พฤหัสบดี',
      'Friday': 'ศุกร์',
      'Saturday': 'เสาร์',
      'Sunday': 'อาทิตย์'
    };
  
    // Convert to Thai if mapping exists, otherwise return the original value
    return dayMapping.hasOwnProperty(dayOfWeek) ? dayMapping[dayOfWeek] : dayOfWeek;
  }

  export const getValidDays = (data) => {
    const today = new Date();
    const uniqueValidDays = new Set();

    data.forEach((day) => {
      const startDate = new Date(day.start_date);
      const endDate = day.end_date ? new Date(day.end_date) : null;

      if (today >= startDate && (!endDate || today <= endDate)) {
        uniqueValidDays.add(day.day);
      }
    });

    const sortedValidDays = Array.from(uniqueValidDays).sort((day1, day2) => {
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return daysOfWeek.indexOf(day1) - daysOfWeek.indexOf(day2);
    });

    const arr = [];
    sortedValidDays.forEach((d) => {
      arr.push(mapDayToThaiShortName(d));
    });

    return arr.join(", ");
  };